import React, { useState } from 'react';

const CategorySelector = ({ categories, selectedCategory, onChange, onCreateCategory }) => {
  const [isCreating, setIsCreating] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [saving, setSaving] = useState(false);

  const handleCreate = async () => {
    const trimmed = newCategoryName.trim();
    if (!trimmed) return;
    if (categories.includes(trimmed)) {
      alert('Category already exists');
      return;
    }
    setSaving(true);
    try {
      await onCreateCategory(trimmed);
      onChange(trimmed);
      setNewCategoryName('');
      setIsCreating(false);
    } catch (error) {
      console.error('Error creating category:', error);
    } finally {
      setSaving(false);
    }
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;
    if (value === '__create__') {
      setIsCreating(true);
    } else {
      onChange(value);
    }
  };

  if (isCreating) {
    return (
      <div className="flex gap-2">
        <input
          type="text"
          value={newCategoryName}
          onChange={(e) => setNewCategoryName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), handleCreate())}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="Enter new category name"
          autoFocus
        />
        <button
          type="button"
          onClick={handleCreate}
          disabled={saving}
          className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50"
        >
          {saving ? 'Adding...' : 'Add'}
        </button>
        <button
          type="button"
          onClick={() => { setIsCreating(false); setNewCategoryName(''); }}
          className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
      </div>
    );
  }

  return (
    <select
      value={selectedCategory}
      onChange={handleSelectChange}
      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
    >
      <option value="">Select a category...</option>
      {categories.map(category => (
        <option key={category} value={category}>{category}</option>
      ))}
      <option value="__create__">+ Create New Category</option>
    </select>
  );
};

export default CategorySelector;
